<template>
  <b-modal
    :id="modalId"
    ref="modalInsufficientCreditViralClone"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="!p-0"
    dialog-class="modal-dialog-centered !max-w-[440px] !w-full mx-auto"
    content-class="!rounded-[20px] !border-0 overflow-hidden bg-white"
  >
    <div class="bg-white rounded-[20px] py-8 px-6 w-full mx-auto flex flex-col items-center">
      <!-- Icon -->
      <div class="flex items-center justify-center mb-5">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="Warning"
          width="96"
          height="96"
          class="w-24 h-24"
          @error="handleImageError"
        >
      </div>

      <!-- Text -->
      <h4 class="text-center font-semibold text-[20px] text-[#1f1f1f] mb-2 mt-0">
        Kredit Tidak Cukup
      </h4>
      <p class="text-center text-[#737373] text-sm leading-relaxed mb-7 mt-0 max-w-[320px]">
        Fitur Viral Clone membutuhkan 500 kredit. Top up kredit terlebih dahulu untuk menggunakan fitur ini.
      </p>

      <!-- Actions -->
      <div class="flex w-full gap-3">
        <button
          type="button"
          class="flex-1 h-[44px] rounded-[12px] font-medium text-sm text-[#1f1f1f] bg-white border border-[#d9d9d9] hover:bg-[#fafafa] hover:border-[#bfbfbf] m-0 transition-all duration-200 outline-none focus:outline-none flex items-center justify-center cursor-pointer"
          @click="handleClose"
        >
          Batal
        </button>
        <button
          type="button"
          class="flex-1 h-[44px] rounded-[12px] font-medium text-sm text-white bg-[#F95E16] hover:bg-[#ff7d32] border-0 m-0 transition-all duration-200 outline-none focus:outline-none flex items-center justify-center cursor-pointer"
          @click="handleTopup"
        >
          Top Up Kredit
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
    handleTopup() {
      this.handleClose()
      this.$emit('topup')
    },
    handleImageError(e) {
      e.target.outerHTML = `<svg width="96" height="96" viewBox="0 0 142 136" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="39.7262" cy="94.8856" rx="39.7262" ry="40.328" fill="#FBA63C"/>
        <path d="M141.401 68.0001C141.401 104.787 111.398 134.615 74.3803 134.615C37.3621 134.615 7.35913 104.787 7.35913 68.0001C7.35913 31.2128 37.3621 1.38464 74.3803 1.38464C111.398 1.38464 141.401 31.2128 141.401 68.0001Z" fill="#FBA63C"/>
        <ellipse cx="119.672" cy="25.9922" rx="16.5526" ry="16.8033" fill="#FBA63C"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M41.0225 67.8298C41.0225 49.4368 56.0429 34.5032 74.5502 34.5032C93.0911 34.5032 108.078 49.4368 108.078 67.8298C108.078 86.2294 93.0911 101.156 74.5502 101.156C56.0429 101.156 41.0225 86.2294 41.0225 67.8298ZM71.5998 55.1988C71.5998 53.6024 72.9409 52.266 74.5502 52.266C76.1595 52.266 77.4671 53.6024 77.4671 55.1988V69.9291C77.4671 71.5321 76.1595 72.8285 74.5502 72.8285C72.9409 72.8285 71.5998 71.5321 71.5998 69.9291V55.1988ZM74.5849 83.4295C72.942 83.4295 71.6344 82.0964 71.6344 80.4967C71.6344 78.8971 72.942 77.5973 74.5513 77.5973C76.1942 77.5973 77.5018 78.8971 77.5018 80.4967C77.5018 82.0964 76.1942 83.4295 74.5849 83.4295Z" fill="white"/>
      </svg>`
    },
  },
}
</script>
